export enum VideoAction {
  Create,
  Update,
}
